var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-tabs', {
    attrs: {
      "nav-class": "v-nav",
      "pills": "",
      "vertical": ""
    }
  }, [_c('b-tab', {
    attrs: {
      "title": "Jersey",
      "active": ""
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.jerseys,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Head Gear"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.helmet,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Shoes"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.shoes,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Socks"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.socks,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Gloves"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.gloves,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1), _c('b-tab', {
    attrs: {
      "title": "Eye wear"
    }
  }, [_c('Product', {
    attrs: {
      "products": _vm.glasses,
      "user-gems": _vm.userGems,
      "user-coins": _vm.userCoins
    },
    on: {
      "activateModalChild": _vm.activateModalChild
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }